import { render } from "./ClientAddDialog.vue?vue&type=template&id=2c2c01c2"
import script from "./ClientAddDialog.vue?vue&type=script&lang=js"
export * from "./ClientAddDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__